import React from 'react';

const OG_LOCALE = {
  tr: 'tr_TR',
  en: 'en_US',
  de: 'de_DE',
  fr: 'fr_FR',
  es: 'es_ES',
  ar: 'ar_SA',
  ru: 'ru_RU',
  zh: 'zh_CN',
  fa: 'fa_IR',
};

/**
 * Open Graph + Twitter Card — Helmet içinde doğrudan kullanın:
 * <Helmet>{renderSocialMetaTags({ title, ... })}</Helmet>
 * (Helmet özel bileşen kabul etmez, yalnızca meta/link/script vb.)
 */
export function renderSocialMetaTags({
  title,
  description,
  url,
  image,
  type = 'website',
  siteName = 'Turkish E-Market',
  locale,
}) {
  if (!title) return null;

  const ogLocale = locale ? OG_LOCALE[locale] || locale : undefined;
  const cardType = image ? 'summary_large_image' : 'summary';

  return [
    <meta key="og-type" property="og:type" content={type} />,
    <meta key="og-title" property="og:title" content={title} />,
    description ? <meta key="og-desc" property="og:description" content={description} /> : null,
    url ? <meta key="og-url" property="og:url" content={url} /> : null,
    image ? <meta key="og-image" property="og:image" content={image} /> : null,
    <meta key="og-site" property="og:site_name" content={siteName} />,
    ogLocale ? <meta key="og-locale" property="og:locale" content={ogLocale} /> : null,
    <meta key="tw-card" name="twitter:card" content={cardType} />,
    <meta key="tw-title" name="twitter:title" content={title} />,
    description ? <meta key="tw-desc" name="twitter:description" content={description} /> : null,
    image ? <meta key="tw-image" name="twitter:image" content={image} /> : null,
  ].filter(Boolean);
}
